import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Mail, Phone, Facebook, Instagram, Linkedin, MessageCircle } from 'lucide-react';

// TikTok icon component (not available in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  const { t, language } = useLanguage();

  const socialLinks = [
    { icon: Facebook, href: "https://web.facebook.com/roomiahomes", label: "Facebook" },
    { icon: Instagram, href: "https://www.instagram.com/roomia_net", label: "Instagram" },
    { icon: Linkedin, href: "https://www.linkedin.com/company/roomia-net", label: "LinkedIn" },
    { icon: TikTokIcon, href: "https://tiktok.com/@roomia.net", label: "TikTok" },
    { icon: MessageCircle, href: "https://whatsapp.com/channel/0029Vb7EeGFI1rcn5O4BKP2v", label: "WhatsApp Channel" },
  ];

  return (
    <footer className="bg-slate-900 border-t border-slate-700 mt-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <img 
              src="/logo.png" 
              alt="Roomia.net" 
              className="h-14 w-auto"
            />
          </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              {t('aboutText')}
            </p>
            <div className="space-y-2 text-sm text-slate-400">
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                <span>Yaoundé, Cameroun</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <a href="tel:+237682329126" className="hover:text-primary transition-colors">+237 682 329 126</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a href="mailto:contact@roomia.net" className="hover:text-primary transition-colors">contact@roomia.net</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4 text-white">{t('quickLinks')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/listings" className="text-slate-400 hover:text-primary transition-colors">
                  {t('listings')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-400 hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-primary transition-colors">
                  {t('contact')}
                </Link>
              </li>
              <li>
                <Link to="/partnership" className="text-slate-400 hover:text-primary transition-colors">
                  {t('partnership')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold mb-4 text-white">{t('legal')}</h4>
            <ul className="space-y-2 text-sm mb-6">
              <li>
                <Link to="/legal#cgu" className="text-slate-400 hover:text-primary transition-colors">
                  {t('cguTitle')}
                </Link>
              </li>
              <li>
                <Link to="/legal#privacy" className="text-slate-400 hover:text-primary transition-colors">
                  {t('privacyTitle')}
                </Link>
              </li>
            </ul>
            
            {/* Social Links */}
            <h4 className="font-heading font-semibold mb-4 text-white">
              {language === 'fr' ? 'Suivez-nous' : 'Follow Us'}
            </h4>
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 rounded-full bg-slate-800 hover:bg-primary flex items-center justify-center text-slate-400 hover:text-white transition-all duration-300"
                    aria-label={social.label}
                    data-testid={`social-${social.label.toLowerCase().replace(' ', '-')}`}
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm text-slate-500">
          <p>{t('copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
